import React, { Component } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';

class AssigneeDropdown extends Component {
    
    render() {
        var assignees = this.props.assignees;
        var currentId = this.props.value || '';
        var onChange = this.props.onChange;

        return (
            <FormControl size="small" style={{ minWidth: 150 }}>
                <Select
                    className="cro__assignee-dropdown"
                    variant="outlined"
                    value={currentId}
                    onChange={function(e) { onChange(e.target.value); }}
                    displayEmpty
                    onClick={function(e) { e.stopPropagation(); }}
                >
                    <MenuItem value="">
                        <em>— Nepřiřazeno —</em>
                    </MenuItem>
                    {assignees.map(function(a) {
                        return <MenuItem key={a.id} value={a.id}>{a.name}</MenuItem>;
                    })}
                </Select>
            </FormControl>
        );
    }
}

export default AssigneeDropdown;